import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'app-page-indicator',
  templateUrl: './page-indicator.component.html',
  styleUrls: ['./page-indicator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageIndicatorComponent {
  readonly currentPage = input.required<number>();
  readonly totalPages = input.required<number>();

  get pages(): number[] {
    return Array.from({ length: this.totalPages() }, (_, i) => i);
  }
}
